module.exports = __webpack_public_path__ + "img/Flag_of_Tonga.f4d05f56.svg";